import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { translations } from '../locales/translations';
import './Support.css';

function Support() {
  const { language } = useContext(LanguageContext);
  const t = translations[language].support;

  const faqs = [
    { question: t.faq1_q, answer: t.faq1_a },
    { question: t.faq2_q, answer: t.faq2_a },
    { question: t.faq3_q, answer: t.faq3_a },
    { question: t.faq4_q, answer: t.faq4_a },
    { question: t.faq5_q, answer: t.faq5_a }
  ];

  return (
    <div className="support-page">
      <div className="page-header">
        <div className="container">
          <h1 className="page-title">{t.title}</h1>
          <p className="page-intro">{t.intro}</p>
        </div>
      </div>

      <div className="section">
        <div className="container">
          {/* Contact Section */}
          <div className="support-card">
            <h2 className="support-section-title">{t.contact_title}</h2>
            <p className="support-description">{t.contact_desc}</p>
            <div className="contact-info">
              <span className="contact-label">{t.email_label}</span>
              <a href="mailto:wsmslgh@gmail.com" className="contact-email">
                wsmslgh@gmail.com
              </a>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="support-card">
            <h2 className="support-section-title">{t.faq_title}</h2>
            <div className="faq-list">
              {faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                  <h3 className="faq-question">{faq.question}</h3>
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>

          {/* System Requirements */}
          <div className="support-card">
            <h2 className="support-section-title">{t.system_title}</h2>
            <ul className="requirements-list">
              <li>{t.system_ios}</li>
              <li>{t.system_device}</li>
              <li>{t.system_storage}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
